/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

var BrowserData = {};
var BrowserInfo = new Class({
    options:{
        'safariTest': new RegExp('safari','ig'),
        'chromeTest': new RegExp('chrome','ig'),
        'firefoxTest': new RegExp('firefox','ig'),
        'internetExplorerTest': new RegExp('MSIE','ig'),
        'internetExplorerNewTest': new RegExp('microsoft','ig'),
        'mobileTest': new RegExp('mobile','ig'),
        'ipadTest': new RegExp('ipad','ig'),
        'iphoneTest': new RegExp('iphone','ig'),
        'androidTest': new RegExp('android','ig'),
        'isWindows': new RegExp('windows','ig'),
        'isApple': new RegExp('macintosh','ig')
    },
    initialize: function(userAgent){
        this.isSafari = (this.options.safariTest.test(userAgent) && !this.options.chromeTest.test(userAgent))? true : false;
        this.isChrome = (this.options.chromeTest.test(userAgent))? true : false;
        this.isFirefox = (this.options.firefoxTest.test(userAgent))? true : false;
        this.isIE = (this.options.internetExplorerTest.test(userAgent))? true : false;
        this.isIE_new = (this.options.internetExplorerNewTest.test(userAgent))? true : false;
        this.isMobile = (this.options.mobileTest.test(userAgent))? true : false;
        this.isIPad = (this.options.ipadTest.test(userAgent))? true : false;
        this.isIPhone = (this.options.iphoneTest.test(userAgent))? true : false;
        this.isAndroid = (this.options.androidTest.test(userAgent))? true : false;
        this.isWindows = (this.options.isWindows.test(userAgent))? true : false;
        this.isMac = (this.options.isApple.test(userAgent))? true : false;

        // browser
        if(this.isSafari){
            BrowserData.Name = 'Safari';
        }else if(this.isChrome || this.options.chromeTest.test(userAgent)){
            BrowserData.Name = 'Chrome';
        }else if(this.isFirefox){
            BrowserData.name = 'Firefox';
        }else if(this.isIE || this.isIE_new){
            BrowserData.Name = 'IE';
        }else{
            BrowserData.Name = 'other';
        }

        // mobile or not
        if(this.isMobile){
            BrowserData.isMobile = true;
        }else{
            BrowserData.isMobile = false;
        }

        // device
        if(this.isIPad){
            BrowserData.Device = 'iPad';
        }else if(this.isIPhone){
            BrowserData.Device = 'iPhone';
        }else if(this.isAndroid){
            BrowserData.Device = 'Android';
        }else{
            if(this.isMobile){
                BrowserData.Device = 'Handheld';
            }else{
                BrowserData.Device = 'Desktop';
            }
        }

        // screen mode
        if(window.getSize().y > window.getSize().x){
            if(this.isMobile){
                BrowserData.Orientation = 'Handheld Portrait';
            }else{
                BrowserData.Orientation = 'Desktop Standing';
            }
        }else{
            if(this.isMobile){
                BrowserData.Orientation = 'Handheld Landscape';
            }else{
                BrowserData.Orientation = 'Desktop Laying';
            }
        }

        // platform
        if(this.isWindows){
            BrowserData.Platform = 'Windows';
        }else{
            if(['iPad','iPhone'].indexOf(BrowserData.Device) >= 0){
                var version = userAgent.match(/OS\s{1}(\d+_\d+)/g)[0].replace('OS ','').replace('_','.');
                BrowserData.Platform = 'iOS ' + version;
            }else{
                if(this.isMac){
                    BrowserData.Platform = 'MacOS';
                }else{
                    BrowserData.Platform = 'Other';
                }
            }
        }

        // Brand
        if(['iOS','MacOS'].indexOf(BrowserData.Platform) >= 0 || ['iPhone','iPad'].indexOf(BrowserData.Device) >= 0){
            BrowserData.Brand = 'Apple';
        }else{
            if(this.isMobile){
                BrowserData.Brand = 'Unknown handheld manufacturer';
            }else{
                BrowserData.Brand = 'Unknown PC manufacturer';
            }
        }

        // version
        BrowserData.Info = navigator;
    }
});
new BrowserInfo(navigator.userAgent);